import { ArrowLeftRight } from 'lucide-react'

import { ActionInfo, Button } from '@krp/ui-kit'

import { SourceHealthSignal } from '../bindings/platform/SourceHealthSignal'
import { CONNECTION_FORMS } from '../composition/connectionForms'
import type { SectionResource } from './sectionTabs'

/**
 * Полоса «Источник» над окнами раздела, который начинается с выбора плитками (`section.pickResource`): какая база или
 * кабинет открыты сейчас, и одна кнопка «Сменить источник» — к плиткам. Одна и та же для всех разделов и видов: вид даёт
 * только метку и слово из формы подключения. Связь с источником полоса не пишет: она уходит сигналом в точку «Связь»
 * шапки (RP-UI-LINK, шаг 3).
 */
export function SectionSourceBar({ source, onChange }: { source: SectionResource | undefined; onChange: () => void }) {
  const resourceKind = source?.resource.kind ?? null
  const noun = resourceKind === null ? 'Источник' : CONNECTION_FORMS.sourceNounOf(resourceKind)
  const tone = resourceKind === null ? null : CONNECTION_FORMS.toneOf(resourceKind)
  return (
    <div className="shell-source-bar" role="group" aria-label="Источник" {...(tone === null ? {} : { 'data-source': tone })}>
      {source !== undefined && <SourceHealthSignal resource={source.resource} />}
      {resourceKind !== null && <span className="shell-section-kind">{CONNECTION_FORMS.shortTitleOf(resourceKind)}</span>}
      <span className="shell-source-bar__name">
        <b>{noun}</b>
        {source !== undefined && <> · {source.resource.displayName}</>}
      </span>
      <ActionInfo id="shell.section-source-change" label="Сменить источник">
        <Button variant="secondary" data-size="sm" icon={<ArrowLeftRight size={14} aria-hidden="true" />} onClick={onChange}>
          Сменить источник
        </Button>
      </ActionInfo>
    </div>
  )
}
